import { createAsset, createPolicy, createProperty } from "./document.js";

export function findSampleClass(document) {
  const property = document.properties.find((item) => normalizedName(item.name) === "class");
  const value = property?.values.find((item) => normalizedName(item.name) === "stocks");
  return property && value ? { property, value } : null;
}

export function createSampleProperty(document, createId) {
  if (document.properties.length) throw new Error("A sample property can only be added when Properties is empty.");
  return createProperty(document, {
    name: "Class",
    values: [{ name: "Stocks" }, { name: "Bonds" }, { name: "Cash" }]
  }, createId);
}

export function createSampleAsset(document) {
  if (document.assets.length) throw new Error("A sample asset can only be added when Assets is empty.");
  const selection = findSampleClass(document);
  if (!selection) throw new Error("Add the sample Class property before adding the sample asset.");
  return createAsset(document, {
    id: "SPY",
    name: "SPDR S&P 500 ETF Trust",
    assignments: [{ propertyId: selection.property.id, valueId: selection.value.id }]
  });
}

export function createSamplePolicy(document, createId) {
  if ((document.policies ?? []).length) throw new Error("A sample policy can only be added when Policies is empty.");
  const selection = findSampleClass(document);
  if (!selection) throw new Error("Add the sample Class property before adding the sample policy.");
  return createPolicy(document, {
    scope: { type: "specific", propertyId: selection.property.id, valueId: selection.value.id },
    must: { maximum: 8000 },
    should: { maximum: 7000 }
  }, createId);
}

function normalizedName(value) {
  return String(value ?? "").trim().toLocaleLowerCase();
}
